module.exports = __webpack_public_path__ + "img/Step1.85069464.png";